import { render, staticRenderFns } from "./config.vue?vue&type=template&id=c01f8052&scoped=true"
import script from "./config.vue?vue&type=script&lang=ts"
export * from "./config.vue?vue&type=script&lang=ts"
import style0 from "./config.vue?vue&type=style&index=0&id=c01f8052&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c01f8052",
  null
  
)

export default component.exports